import { useState } from 'react';
import { Sparkles, Database, Lightbulb, ShieldAlert, CheckCircle } from 'lucide-react';

// 字段聚焦浮层：聚焦该字段时旁边弹出 AI 引导（解释 / 推荐值可采纳 / 事实型只解释）
// meta: { nature:'fact'|'experience', explain, recommend? }
export default function FieldGuide({ label, value, meta, onAdopt, children }) {
  const [focused, setFocused] = useState(false);
  const isExp = meta?.nature === 'experience';

  return (
    <div className="relative" onFocus={() => setFocused(true)} onBlur={() => setTimeout(() => setFocused(false), 150)}>
      {children}
      {focused && meta && (
        <div className="absolute left-0 top-full mt-1.5 w-72 bg-white border border-indigo-200 rounded-xl shadow-lg p-3 z-30">
          <div className="absolute left-4 -top-1.5 w-3 h-3 bg-white border-l border-t border-indigo-200 rotate-45" />
          <div className="flex items-center gap-1.5 mb-1.5">
            <div className="w-5 h-5 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-full flex items-center justify-center"><Sparkles className="w-3 h-3 text-white" /></div>
            <span className="text-xs font-medium text-gray-700">AI 引导 · {label}</span>
            <span className={`text-[10px] px-1.5 py-0.5 rounded ml-auto ${isExp ? 'bg-amber-50 text-amber-600' : 'bg-gray-100 text-gray-500'}`}>{isExp ? '经验型' : '事实型'}</span>
          </div>
          <div className="flex items-start gap-1.5 text-xs text-gray-600 leading-relaxed">
            <Database className="w-3 h-3 text-blue-400 mt-0.5 flex-shrink-0" />
            <span>{meta.explain}</span>
          </div>
          {isExp && meta.recommend != null && (
            <div className="mt-2 pt-2 border-t border-gray-100 flex items-center gap-2">
              <Lightbulb className="w-3.5 h-3.5 text-amber-500 flex-shrink-0" />
              <span className="text-xs text-gray-500 flex-1">推荐 <strong className="text-amber-600">{meta.recommend}</strong></span>
              {String(value) === String(meta.recommend)
                ? <span className="text-[11px] text-green-600 flex items-center gap-0.5"><CheckCircle className="w-3 h-3" /> 已是推荐值</span>
                : <button onMouseDown={(e) => { e.preventDefault(); onAdopt?.(meta.recommend); }} className="text-[11px] px-2 py-0.5 bg-amber-500 text-white rounded hover:bg-amber-600">采纳</button>}
            </div>
          )}
          {meta.nature === 'fact' && (
            <div className="mt-1.5 flex items-center gap-1 text-[11px] text-gray-400"><ShieldAlert className="w-3 h-3" /> 事实型字段，需按现场填写，AI 不代填</div>
          )}
        </div>
      )}
    </div>
  );
}
